import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { registerSW } from 'virtual:pwa-register';
import './styles.css';
import { App } from './App';
import { readConfig } from './config';
import { serviceWorkerSupported } from './pwa/register-sw';
import { createServices } from './services';

const services = createServices(readConfig(import.meta.env, window.location.origin), {
  ...(serviceWorkerSupported() ? { registerSW } : {}),
});

const root = document.getElementById('root');
if (!root) throw new Error('#root element missing');
createRoot(root).render(
  <StrictMode>
    <App services={services} />
  </StrictMode>,
);
